import { useEffect, RefObject } from 'react';

export const useUpdatePositions = (
  yearRef: RefObject<HTMLElement | null>,
  tableContainerRef: RefObject<HTMLDivElement | null>,
  setTooltipPosition: (position: { top: number; left: number }) => void,
  setYearPosition: (position: { top: number; left: number }) => void,
  selectedYear: string | number,
  isTooltipVisible: boolean,
) => {
  useEffect(() => {
    const updatePositions = () => {
      const container = tableContainerRef.current;
      if (yearRef.current && container && selectedYear) {
        const yearRect = yearRef.current.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const scrollLeft = container.scrollLeft;
        const scrollTop = container.scrollTop;

        const newYearPosition = {
          top: yearRect.top - containerRect.top + scrollTop,
          left: yearRect.left - containerRect.left + scrollLeft,
        };

        setYearPosition(newYearPosition);
        setTooltipPosition({
          top: newYearPosition.top + yearRect.height - 20,
          left: newYearPosition.left,
        });
      }
    };

    updatePositions();

    const resizeObserver = new ResizeObserver(updatePositions);
    if (tableContainerRef.current) {
      resizeObserver.observe(tableContainerRef.current);
    }

    window.addEventListener('resize', updatePositions);
    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', updatePositions);
    };
  }, [yearRef, tableContainerRef, setTooltipPosition, setYearPosition, selectedYear, isTooltipVisible]);
};
